import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { SMLRoutes } from '../../../routing/sml/SMLRoutes';
import { useSMLRouter } from '../../../routing/sml/hooks';
import { SMLPageHead } from '../components/SMLPageHead/SMLPageHead';
import { smlNavigationGroupMessages } from '../navigation/smlNavigationMessages';
import { chartsTabLabels, ChartsTabScreen } from './chartsTabs';
import { chartsMessages } from './chartsMessages';
import { ChartsTabRow } from './ChartsTabRow';

interface ChartsPageHeadProps {
  /** The tab on screen. */
  tab: ChartsTabScreen;
}

/**
 * The head of every Charts tab (design navigation-v2 e 5a): the crumbs Discover / Charts / tab, the
 * title "Charts", one line, and the tools of the tab (the date picker) in the actions slot.
 */
const ChartsPageHeadComponent: React.FC<React.PropsWithChildren<ChartsPageHeadProps>> = ({ tab, children }) => {
  const intl = useIntl();
  const router = useSMLRouter();
  const breadcrumbs = useMemo(
    () => [
      { name: intl.formatMessage(smlNavigationGroupMessages.publicName) },
      { name: intl.formatMessage(chartsMessages.title), onClick: () => router.push(SMLRoutes.trends) },
      { name: intl.formatMessage(chartsTabLabels[tab]) },
    ],
    [intl, router, tab]
  );

  return (
    <SMLPageHead
      breadcrumbs={breadcrumbs}
      title={intl.formatMessage(chartsMessages.title)}
      subtitle={intl.formatMessage(chartsMessages.subtitle)}
      tabs={<ChartsTabRow screen={tab} inHead />}
    >
      {children}
    </SMLPageHead>
  );
};

export const ChartsPageHead = TypedMemo(ChartsPageHeadComponent);
